import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { tokenInterceptor } from "@shared/interceptors/token/token.interceptor";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { defineLocale, heLocale } from "ngx-bootstrap/chronos";
import localeHe from "@angular/common/locales/he";
import { setDefaultOptions } from "date-fns";
import { he } from "date-fns/locale";
import { registerLocaleData } from "@angular/common";
import { provideLogger } from "@shared/providers/logger.provider";
import { environment } from "@shared/environments/environment";

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useValue: "he-IL" },

        // Provide the LoggerService with the server endpoint for logging.
        provideLogger(environment.urlservbeautech + "/api/Values/Logs"),

        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([tokenInterceptor])),
        provideAnimations(),

        provideAppInitializer(() => {
            defineLocale("he", heLocale);
            inject(BsLocaleService).use("he");
            registerLocaleData(localeHe);
            setDefaultOptions({ locale: he });
        }),

        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: ".dark-theme",
                },
            },
        }),
    ],
};
